export default function ServicesFive(){
    return(
        <div className="services-area pt-120 pt-md-60 pt-xs-60 pb-100 pb-xs-50 home-5">
			<div className="container">
				<div className="rts-heading">
					<div className="title-inner">
						<div className="sub-text">Our Services</div>
						<div className="title">We Offer a Leading<br />
							<b>IT Solution</b> World Wide</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-5/h4-feature-icon-1.webp" alt="" />
								</div>
							</div>
							<div className="services-bottom">
								<div className="services-title">
									<h2 className="title">Data Analytics</h2>
								</div>
								<p className="services-text">
									Corrupti magni voluptas assum enda, vitae nec dolores mole stie numquam totam,
									atquep
								</p>
							</div>
							<div className="services-btn-part">
								<div className="services-btn">
									<a href="#"><i className="fal fa-long-arrow-right"></i></a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-5/h4-feature-icon-2.webp" alt="" />
								</div>
							</div>
							<div className="services-bottom">
								<div className="services-title">
									<h2 className="title">Web Development</h2>
								</div>
								<p className="services-text">
									Weins ipsum dolor sit amet, cons adipisciit sed do eius modonr temeiusmod fugiat
									fames
								</p>
							</div>
							<div className="services-btn-part">
								<div className="services-btn">
									<a href="#"><i className="fal fa-long-arrow-right"></i></a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-5/h4-feature-icon-3.webp" alt="" />
								</div>
							</div>
							<div className="services-bottom">
								<div className="services-title">
									<h2 className="title">UX/UI Design</h2>
								</div>
								<p className="services-text">
									Optio dicta sapien, dolorem, habit asse aliquid numquam, nisi etia dignissim eiusmod
								</p>
							</div>
							<div className="services-btn-part">
								<div className="services-btn">
									<a href="#"><i className="fal fa-long-arrow-right"></i></a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
						<div className="services-wraper">
							<div className="services-top">
								<div className="services-icon">
									<img src="assets/img/home-5/h4-feature-icon-4.webp" alt="" />
								</div>
							</div>
							<div className="services-bottom">
								<div className="services-title">
									<h2 className="title">QA &amp; Testing</h2>
								</div>
								<p className="services-text">
									Fugiat pariatur vestibulum eges tas wisi ullamcorper, sagittis duis praesent autem
									accusan
								</p>
							</div>
							<div className="services-btn-part">
								<div className="services-btn">
									<a href="#"><i className="fal fa-long-arrow-right"></i></a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="faq-area">
					<h3 className="ques-text">
						Are you a driven and motivated 1st Line IT Support Engineer? <a href="#">Now Hiring!</a>
					</h3>
				</div>
			</div>
		</div>
    )
}